import { BoxStyled } from 'pages/Gateways/components/GatewaysForm.styled';
import { Alert } from 'shared/mui/Alert/Alert';
import { Box } from 'shared/mui/Box';

import { GatewaysCreateBooleanFields } from './components/GatewaysCreateBooleanFields';
import { GatewaysCreateCurrenciesFields } from './components/GatewaysCreateCurrenciesFields';
import { GatewaysCreateMainFields } from './components/GatewaysCreateMainFields';
import { GatewaysCreateStatusRequestFields } from './components/GatewaysCreateStatusRequestFields';

export const GatewaysBulkCreateForm: React.FC = () => (
  <Box pt="24px">
    <Alert severity="info" sx={{ mb: 3 }}>
      Будут созданы два шлюза с одинаковыми настройками, но с разными значениями в названии и
      внешнем алиасе: FTD и TTD.
      <br />
      Метод будет создан автоматически для каждого шлюза.
    </Alert>
    <BoxStyled sx={{ rowGap: 0 }}>
      <GatewaysCreateMainFields />
      <GatewaysCreateCurrenciesFields />
    </BoxStyled>
    <GatewaysCreateStatusRequestFields />
    <GatewaysCreateBooleanFields />
  </Box>
);
